import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { Fetch } from "../../shared/Fetch";
import { JVDate } from "../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ILogin } from "../../models/Login";
import { MultiSelect } from "primereact/multiselect";

export interface IRateChangeFilter {
  From_Date?: Date | null;
  To_Date?: Date | null;
  Consultant_Name?: string | null;
  Company?: number | null;
  CompanyType?: string | null;
  Branch?: number[] | null;
  Team_Name?: number | null;
  SM?: number | null;
  Recruiter?: number | null;
  Branch_Approved_By?: number | null;
  Admin_Approved_By?: number | null;
  Branch_Action_Status?: boolean | null | string;
  Admin_Action_Status?: boolean | null | string;
}

 const getDefaultDates = () => {
  const today = new Date();
  const lastWeek = new Date();
  lastWeek.setDate(today.getDate() - 7);
  return { From_Date: lastWeek, To_Date: today };
};

export const EmptyRateCahngeFilter: any = {
  From_Date: getDefaultDates().From_Date,  
  To_Date: getDefaultDates().To_Date, 
  Consultant_Name: "",
  Company: null,
  CompanyType: null,
  Branch: null,
  Team_Name: null,
  SM: null,
  Recruiter: null,
  Branch_Approved_By: null,
  Admin_Approved_By: null,
  Branch_Action_Status: null,
  Admin_Action_Status: null,
};

const schema = yup.object({
  From_Date: yup.date().nullable(),
  To_Date: yup.date().nullable(),
  Consultant_Name: yup.string().nullable(),
  Company: yup.number().nullable(),
  CompanyType: yup.string().nullable(),
  Branch: yup.string().nullable(),
  SM: yup.number().nullable(),
  Recruiter: yup.number().nullable(),
  Branch_Approved_By: yup.number().nullable(),
  Admin_Approved_By: yup.number().nullable(),
  Branch_Action_Status: yup.mixed().nullable(),
  Admin_Action_Status: yup.mixed().nullable(),
});

interface Iprops {
  filters: IRateChangeFilter;
  setFilters: (filters: IRateChangeFilter) => void;
}

const approvalStatusOptions = [
  { label: "-- SELECT --", value: null },
  { label: "Approved", value: "true" },
  { label: "Rejected", value: "false" },
  { label: "Pending", value: "pending" },
];

export const Filter = (props: Iprops) => {
  const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
  const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
  const [sm, setSM] = useState<Array<IUsersDropdown>>();
  const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
  const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);

  let _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => _roles.push(role.role_ID));

  const { control, handleSubmit, watch, reset } = useForm<IRateChangeFilter>({
    resolver: yupResolver(schema),
    defaultValues: props.filters,
    shouldFocusError: false,
  });

  const loadSm = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
    let q = null;
    if (team !== 0 && team != null) q = `team_ID=${team}`;
    else if (branch && branch.length > 0 && branch[0] !== 0) q = branch.map((b) => `branch_ID=${b}`).join("&");
    else if (company !== 0 && company != null) q = `company_ID=${company}`;
    const res = await Fetch("Dropdown/filterUsersListss", "GET", null, q, null);
    if (res) {
      const data: IUsersDropdown[] = await res.json();
      data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
      setSM(data);
    }
  };

  const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined, type?: string) => {
    let q = null;
    if (branch && branch.length > 0 && branch[0] !== 0) q = branch.map((b) => `branch_ID=${b}`).join("&");
    else if (company !== 0 && company != null) q = `company_ID=${company}`;
    if (type && type !== "" && type !== "-- SELECT --") {
      if (type === "sales") q = "user_Type=sales&" + q;
      if (type === "recruiter") q = "user_Type=recruiter&" + q;
    }
    const res = await Fetch("Dropdown/filterTeamsList", "GET", null, q, null);
    if (res) {
      const data: ITeamsDropdown[] = await res.json();
      data.unshift({ team_ID: 0, team_Name: "-- SELECT --" });
    }
  };

  const loadBranch = async (company?: number | null) => {
    const q = company ? `company_id=${company}` : null;
    const res = await Fetch("Dropdown/filterBranchList", "GET", null, q, null);
    if (res) {
      const data: IBranchMastDropdown[] = await res.json();
      data.unshift({ branch_ID: 0, branchName: "-- SELECT --", company_ID: 0 });
      setBranch(data);
    }
  };

  const loadCompany = async () => {
    const res = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
    if (res) {
      const data: ICompanyMastDropdown[] = await res.json();
      data.unshift({ company_ID: 0, company_Name: "-- SELECT --" });
      setCompany(data);
    }
  };

  //   const loadRecruiters = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
  //     let q = null;

  //     if (team !== 0 && team != null) q = `team_ID=${team}`;
  //     else if (branch && branch.length > 0 && branch[0] !== 0) q = branch.map((b) => `branch_ID=${b}`).join("&");
  //     else if (company !== 0 && company != null) q = `company_ID=${company}`;
  //     console.log(q);
  //     const res = await Fetch("Dropdown/filterUsersListss", "GET", null, q, null);
  //     if (res) {
  //       const data: IUsersDropdown[] = await res.json();
  //       data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
  //       setRecruiters(data);
  //     }
  //   };
  const loadRecruiters = async () => {
    const res = await Fetch("Dropdown/filterUsersListss", "GET", null, "user_Type=recruiter", null);
    if (res) {
      const data: IUsersDropdown[] = await res.json();
      data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
      setRecruiters(data);
    }
  };

  useEffect(() => {
    const sub = watch((value, { name }) => {
      if (name === "CompanyType") {
        const t = value.CompanyType;
        if (t === "recruiter" || t === "sales") loadTeam(control._formValues.Branch, control._formValues.Company, t);
        else if (t != null) loadTeam(control._formValues.Branch, control._formValues.Company, "");
      }
      if (name === "Company") {
        if (value.Company !== 0 && value.Company != null) {
          loadTeam([], value.Company);
          loadSm([], value.Company, 0);
          loadBranch(value.Company);
        } else if (value.Company === 0 && value.Company != null) {
          loadBranch();
          loadTeam(control._formValues.Branch, value.Company);
          loadRecruiters();
          loadSm(control._formValues.Branch, value.Company, control._formValues.Team_Name);
        }
      }
      if (name === "Branch" && selectedBranch.length === 0 && value.Branch != null) {
        loadTeam(selectedBranch, control._formValues.Company);
        loadRecruiters();
        loadSm(selectedBranch, control._formValues.Company, control._formValues.Team_Name);
      }
      if (name === "Team_Name") {
        if (value.Team_Name !== 0 && value.Team_Name != null) {
          loadSm([], 0, value.Team_Name);
          loadRecruiters();
        } else if (value.Team_Name === 0 && value.Team_Name != null) {
          loadRecruiters();
          loadSm(control._formValues.Branch, control._formValues.Company, value.Team_Name);
        }
      }
    });
    return () => sub.unsubscribe();
  }, [watch]);

  //   useEffect(() => {
  //     loadSm([], 0, 0);
  //     loadTeam([], 0);
  //     loadBranch();
  //     loadCompany();
  //     loadRecruiters([], 0, 0);
  //   }, []);

  useEffect(() => {
    loadSm(null, null, null);
    loadRecruiters();
    loadBranch();
    loadCompany();
  }, []);

  useEffect(() => {
    if (selectedBranch.length > 0) {
      loadTeam(selectedBranch, 0);
      loadRecruiters();
      loadSm(selectedBranch, 0, 0);
    }
  }, [selectedBranch]);

  const searchToDB = (body: IRateChangeFilter) => {
    if (selectedBranch.length > 0) body.Branch = selectedBranch;

    let filterData: any = body;
    const empty: any = EmptyRateCahngeFilter;
    for (let key in filterData) {
      if (filterData[key] === "-- SELECT --" || filterData[key] === 0) filterData[key] = empty[key];
      if (key === "Req_ID") filterData["Req_ID"] = filterData["Req_ID"] === "" ? null : Number(filterData["Req_ID"]);
    }
    props.setFilters(filterData);
  };



  const onClear = () => {
    setSelectedBranch([]);
    reset(EmptyRateCahngeFilter);
    loadSm(null, null, null);
    loadBranch();
    loadCompany();
    loadRecruiters();
    props.setFilters(EmptyRateCahngeFilter);
  };

  return (
    <form onSubmit={handleSubmit(searchToDB)} className="p-fluid formgrid grid">
      <JVDate maxDate={new Date()} column={6} label="From Date" control={control} name="From_Date" />
      <JVDate maxDate={new Date()} column={6} label="To Date" control={control} name="To_Date" />

      <>
        <JVInput column={6} label="Consultant Name / Email" type="text" control={control} name="Consultant_Name" />
        <JVDropdown column={6} label="Company Name" control={control} name="Company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
        <div className="field col-2 md:col-2">
          <p>Branch</p>
          <MultiSelect style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branch} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
        </div>
        {/* <JVMultiselect column={6} label="Status" options={status} optionLabel="load_Type" placeholder="Status" value={selectedStatus} onChange={setSelectedStatus} /> */}
        {/* <JVDropdown column={6} label="Req Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Category" /> */}
      </>
      <JVDropdown column={6} label="Sales Manager" control={control} name="SM" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" filter />
      <JVDropdown column={6} label="Recruiter" control={control} name="recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" filter />
      {/* <JVDropdown column={6} label="Branch Approved By" control={control} name="branch_Approved_By" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select User" filter />
      <JVDropdown column={6} label="Admin Approved By" control={control} name="admin_Approved_By" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select User" filter /> */}
      <JVDropdown column={6} label="Branch Action Status" control={control} name="branch_Action_Status" options={approvalStatusOptions} optionLabel="label" optionValue="value" placeholder="-- SELECT --" />
      <JVDropdown column={6} label="Admin Action Status" control={control} name="admin_Action_Status" options={approvalStatusOptions} optionLabel="label" optionValue="value" placeholder="-- SELECT --" />
      <div style={{ margin: "10px 0", width: "100%" }} />
      <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px" }}>
        <Button className="field col-12 md:col-6" label="SEARCH" type="submit" />
        <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" type="button" onClick={onClear} />
      </div>
    </form>
  );
};
